import Magnolia1 from '../../../Media/Greenwood/Cluster Flamboyan/Magnolia/Magnolia (1).png'
import Magnolia2 from '../../../Media/Greenwood/Cluster Flamboyan/Magnolia/Magnolia (2).png'
import Magnolia3 from '../../../Media/Greenwood/Cluster Flamboyan/Magnolia/Magnolia (3).png'


const Magnoliaimages =[
Magnolia1, Magnolia2, Magnolia3,
]

export default Magnoliaimages;